import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//this is a custom theme from elementUI in a local folder
import '../custom-elementUI-theme/theme/index.css'

import locale from 'element-ui/lib/locale/lang/en'

Vue.use(Element, { locale })
